/**
 * MD5 (RFC 1321), which the partition table uses as its checksum. Web
 * Crypto has no MD5, and the tables are a few kilobytes.
 */

const SHIFTS = [
    7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
    4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15,
    21,
];

const SINES = Array.from({ length: 64 }, (_, i) => Math.floor(Math.abs(Math.sin(i + 1)) * 2 ** 32) >>> 0);

export function md5(data: Uint8Array): Uint8Array {
    const padded = new Uint8Array((((data.length + 8) >> 6) + 1) << 6);
    padded.set(data);
    padded[data.length] = 0x80;
    const view = new DataView(padded.buffer);
    view.setUint32(padded.length - 8, (data.length * 8) >>> 0, true);
    view.setUint32(padded.length - 4, Math.floor(data.length / 2 ** 29), true);

    let a0 = 0x67452301;
    let b0 = 0xefcdab89;
    let c0 = 0x98badcfe;
    let d0 = 0x10325476;
    const words = new Uint32Array(16);
    for (let block = 0; block < padded.length; block += 64) {
        for (let i = 0; i < 16; i++) words[i] = view.getUint32(block + i * 4, true);
        let [a, b, c, d] = [a0, b0, c0, d0];
        for (let i = 0; i < 64; i++) {
            let f: number;
            let g: number;
            if (i < 16) [f, g] = [(b & c) | (~b & d), i];
            else if (i < 32) [f, g] = [(d & b) | (~d & c), (5 * i + 1) % 16];
            else if (i < 48) [f, g] = [b ^ c ^ d, (3 * i + 5) % 16];
            else [f, g] = [c ^ (b | ~d), (7 * i) % 16];
            const sum = (a + f + SINES[i]! + words[g]!) >>> 0;
            [a, d, c] = [d, c, b];
            b = (b + ((sum << SHIFTS[i]!) | (sum >>> (32 - SHIFTS[i]!)))) >>> 0;
        }
        a0 = (a0 + a) >>> 0;
        b0 = (b0 + b) >>> 0;
        c0 = (c0 + c) >>> 0;
        d0 = (d0 + d) >>> 0;
    }
    const digest = new Uint8Array(16);
    const out = new DataView(digest.buffer);
    [a0, b0, c0, d0].forEach((word, i) => out.setUint32(i * 4, word, true));
    return digest;
}
